import React from 'react';
import { mergeStyleSets } from '@fluentui/react';

import ButtonTooltip from '@v2/components/base/ButtonTooltip';

const classNames = mergeStyleSets({
  tooltip: {
    textDecoration: 'underline #000 dotted',
  }
});

export default ({ tooltip, label, className }) => {
  return (
    <ButtonTooltip className={className} content={tooltip} styles={{ root: { width: 'auto' } }}>
      <span className={tooltip && classNames.tooltip}>{label}</span>
    </ButtonTooltip>
  );
}
